/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form data for Pickup Groups.
────────────────────────────────────────────────────────────────*/

import type { PickupGroupFormState } from '../types';

export const DEFAULT_SETTINGS = {
  pickup_tone: 'default',
  ringback: 'local',
  confirmation: false,
  DND_override: false,
  pickup_timeout: 10
};

export function createDefaultFormData(): PickupGroupFormState {
  return {
    name: '',
    context: '',
    priority: 100,
    skipBusy: false,
    enabled: true,
    settings: { ...DEFAULT_SETTINGS }
  };
}

